import isWindow from 'dom-helpers/query/isWindow';

const BLACKLIST = ['template', 'script', 'style'];
export function ownerDocument(node) {
  return (node && node.ownerDocument) || document;
}
function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}
function ownerWindow(node, fallback = window) {
  const doc = ownerDocument(node);
  return doc.defaultView || doc.parentView || fallback;
}
export function isOverflowing(container) {
  const doc = ownerDocument(container);
  const win = ownerWindow(doc);

  if (!isWindow(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  }

  // Takes in account potential non zero margin on the body.
  const style = win.getComputedStyle(doc.body);
  const marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  const marginRight = parseInt(style.getPropertyValue('margin-right'), 10);

  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}
function isHideable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, currentNode, callback) {
  const blacklist = [mount, currentNode];

  [].forEach.call(container.children, node => {
    if (blacklist.indexOf(node) === -1 && isHideable(node)) {
      callback(node);
    }
  });
}

export function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

export function ariaHiddenSiblings(container, mountNode, currentNode, show) {
  siblings(container, mountNode, currentNode, node => ariaHidden(node, show));
}



// WEBPACK FOOTER //
// ./src/modal/modalUtil.js